import React, { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button';
import { toast } from "react-toastify";
import * as Yup from 'yup';
import { useNavigate } from 'react-router';
import { SlDrawer, SlInput, SlIcon } from '@shoelace-style/shoelace/dist/react';
import { useFormik } from "formik";
import api from "../../services/api";
import NoDataFound from '../../shared/NoDataFound';
import { Toast } from '../../shared/Toast';
import Paginator from '../../shared/Paginator';
import config from '../../config';
import TableLoader from '../../shared/TableLoader';
import { useSelector } from 'react-redux';
import { roles } from "../../utils/constants";
import { useForm } from "react-hook-form";
import { debounce } from '../../utils/Debounce';
import { SlTooltip, SlIconButton, SlButton } from '@shoelace-style/shoelace/dist/react';
import * as XLSX from 'xlsx';
import { formatDate } from '../../utils/dateFormat';
import { CSVLink } from "react-csv";
import "../creatives/CreativeList.scss";

const initialContacts = {
    name: '',
    designation: '',
    official_email: '',
    personal_email: '',
    mobile: '',
    company: '',
    location: '',
    category: '',
    source: ''
}

let initialValues = JSON.parse(JSON.stringify(initialContacts));

const ContactsSchema = Yup.object().shape({
    name: Yup.string().matches(/^[a-zA-Z][a-zA-Z\s.]*$/, "Name should have only alphabets and .").required('Please enter the Name'),
    official_email: Yup.string().email().nullable(),
    personal_email: Yup.string().email().nullable(),
    mobile: Yup.string().nullable()
        .matches(/^(?:(?:\+\d{1,3}\s?)?(\d{10})|(?:0\d{1,5}\s?(\d{6,8}))|(\d+))$/, "Enter the valid Mobile Number"), // Accepts Mobile number with country code, landline number , Company Number
    location: Yup.string().matches(/^[a-zA-Z][a-zA-Z\s]*$/, "Location can't start with white space and should not contain special characters").nullable(),
    source: Yup.string().matches(/^[a-zA-Z][a-zA-Z\s._]*$/, "Source must have only alphabets").nullable(),
    company: Yup.string().matches(/^(?!\s)[a-zA-Z0-9\s]*$/, "Company must be Alphanumeric").nullable(), // Accepts alphanumeric
    category: Yup.string().matches(/^[a-zA-Z][a-zA-Z\s._]*$/, "Category must have only alphabets").nullable(),
    designation: Yup.string().matches(/^(?!^\s)[a-zA-Z0-9\s@%$&*():;"'/+=\-_.,|]+$/, "Please enter valid designation").required("Please enter the Designation"),
})

function Contacts() {
    const navigate = useNavigate();

    const [delId, setDelId] = useState(-1);
    const [delname, setDelname] = useState("")
    const [del, setDel] = useState(false);
    const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const [loader, setLoader] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [flag, setFlag] = useState('')
    const [id, setId] = useState('');
    const [search, setSearch] = useState("")
    const [totalPages, setTotalPages] = useState(0);
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [userId, setuserId] = useState("")
    const [contactId, setContactId] = useState("")
    const [requestStatus, setRequestStatus] = useState("")
    const [downloadData, setDownloadData] = useState([]);

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
        loadData(search, event.selected);
    };

    const handleClose = () => {
        setShow(false);
        setSubmit(false);
        initialValues = JSON.parse(JSON.stringify(initialContacts));
        formik.setValues(initialValues);
    };

    const handleShow = (choose, item) => {
        if (choose === "add") {
            formik.setValues(item);
            setShow(true);
        }
        if (choose === 'edit') {
            initialValues.name = item.name
            initialValues.designation = item.designation
            initialValues.official_email = item.official_email
            initialValues.personal_email = item.personal_email
            initialValues.mobile = item.mobile
            initialValues.company = item.company
            initialValues.location = item.location
            initialValues.category = item.category
            initialValues.source = item.source
            formik.setValues(initialValues);
            setShow(true)
        }
    };

    // useEffect(() => {
    //     loadData()
    // }, []);

    useEffect(() => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            loadData();
        }
        if (localStorage.getItem("role") === roles.b2b) {
            downloadB2BContacts("")
        }
    }, [contactId]);

    const [selectedRecords, setSelectedRecords] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const toggleCheckbox = (recordId) => {
        if (selectedRecords.includes(recordId)) {
            setSelectedRecords(selectedRecords.filter((id) => id !== recordId));
        } else {
            setSelectedRecords([...selectedRecords, recordId]);
        }
    };

    const toggleSelectAll = () => {
        if (selectAll) {
            setSelectedRecords([]);
        } else {
            const pageRecordIds = data.map((item) => item.contact_id);
            setSelectedRecords(pageRecordIds);
        }
        setSelectAll(!selectAll);
    };


    const deleteContact = async (selectedRecords) => {
        try {
            let res = await api({
                url: `/b2b_contacts/deleteB2BContacts`,
                method: "DELETE",
                responseType: "json",
                data: { ids: selectedRecords }
            });
            if (res?.code !== 200) {
                toast.error(res?.data?.message)
            } else {
                toast.success("Contact Deleted Successfully");
                setCurrentPage(0);
                setSearch('');
                loadData(search, 0);
                downloadB2BContacts(search);
                setSelectedRecords([]);
                setSelectAll(false);
            }
        } catch (error) {
            let er = error?.response?.message || "Something went wrong"
            Toast("error", er)
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const loadData = async (searchString = '', page = 0) => {
        try {
            if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
                setLoader(true);
                let res = await api({
                    url: `/b2b_contacts/get`,
                    method: "POST",
                    responseType: "json",
                    data: {
                        page,
                        limit: 100,
                        search: searchString
                    }
                });
                if (res?.code !== 200) {
                    toast.error(res?.data?.message)

                } else {
                    setData(res.data.data.length ? res.data.data : []);
                    setuserId(res.data.user_id);
                    setTotal(res.data.total || 0);
                    // setTotalPages(Math.ceil(res.data.total / config.PER_PAGE));
                    setTotalPages(Math.ceil(res.data.total / 100));
                    setLoader(false);
                }
            }
        } catch (error) {
            setLoader(false);
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const sendRequest = async (contact_id) => {
        try {
            let res = await api({
                url: `/b2b_contacts/request/${contact_id}`,
                method: "POST",
                responseType: "json"
            });
            if (res?.code === 200) {
                toast.success("Request sent Successfully");
                loadData('', 0)
            } else {
                setRequestStatus(res.data.message)
                toast.error(res.data.message)
            }
        } catch (error) {
            let er = error?.response?.message || "Something went wrong"
            Toast("error", er)
            if (error.response.status === 401)
                navigate("/")
        }

    }

    const searchData = e => {
        setSearch(e.target.value);
        setCurrentPage(0);
        loadData(e.target.value, 0);
        if (localStorage.getItem("role") === roles.b2b) {
            downloadB2BContacts(e.target.value)
        }
    }

    function handleRequestClose(event) {
        if (event.detail.source === 'overlay') {
            event.preventDefault();
        }
    }

    const handledelClose = () => {
        setDel(false)
    };

    // const [jsonData, setJsonData] = useState(null);

    // const handleFileUpload = async (event) => {
    //     const file = event.target.files[0];
    //     if (!file) {
    //         return;
    //     }

    //     try {
    //         const arrayBuffer = await file.arrayBuffer();
    //         const workbook = XLSX.read(arrayBuffer, { type: 'array' });
    //         const sheetName = workbook.SheetNames[0];
    //         const worksheet = workbook.Sheets[sheetName];
    //         const convertedData = XLSX.utils.sheet_to_json(worksheet);
    //         setJsonData(convertedData);
    //     } catch (error) {
    //         console.error('Error converting Excel to JSON:', error);
    //     }
    // };
    const {
        register,
        setValue,
        formState: { errors },
    } = useForm({ mode: "onSubmit" });

    const [file, setFile] = useState(null);
    const [jsonData, setJsonData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const handleFileUpload = async (event) => {
        setFile(event.target.files[0]);
        if (event.target.files[0]) {
            if (event.target.files[0].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                // Throw an error if the file type is not XLSX
                Toast('error', "Please upload file with .xlsx extension")
                return;
            }
            else {
                setIsLoading(true);
                try {
                    const arrayBuffer = await event.target.files[0].arrayBuffer();
                    const workbook = XLSX.read(arrayBuffer, { type: 'array' });
                    let sheetsCount = Object.keys(workbook.Sheets).length;

                    const sheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[sheetName];
                    const convertedData = XLSX.utils.sheet_to_json(worksheet);

                    setJsonData(convertedData);
                    let response = await api({
                        url: `/b2b_contacts/uploadContactFile`,
                        method: "POST",
                        responseType: "json",
                        data: {
                            convertedData,
                            sheetsCount
                        }
                    })

                    if (response.code === 200) {
                        toast.success("Contacts added successfully");
                        loadData('', 0);
                        downloadB2BContacts("")
                        setFile(null)
                    } else {
                        toast.error(response.data.message);
                        loadData('', 0)
                        downloadB2BContacts("")
                        setFile(null)
                    }
                    setIsLoading(false);
                } catch (error) {
                    console.error('Error converting Excel to JSON:', error);
                    setIsLoading(false);
                }
                setValue('file_xlsx', '')
            }
        }
        else {
            return
        }

    };

    const handleConvert = async () => {
        if (!file) {
            return;
        }

        try {
            const arrayBuffer = await file.arrayBuffer();
            const workbook = XLSX.read(arrayBuffer, { type: 'array' });
            let sheetsCount = Object.keys(workbook.Sheets).length;
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            const convertedData = XLSX.utils.sheet_to_json(worksheet);
            setJsonData(convertedData);
            let response = await api({
                url: `/b2b_contacts/uploadContactFile`,
                method: "POST",
                responseType: "json",
                data: {
                    convertedData,
                    sheetsCount
                }
            })
            if (response.code === 200) {
                toast.success("COntacts added successfully")
            } else {
                toast.error(response.data.message)
            }
        } catch (error) {
            console.error('Error converting Excel to JSON:', error);
        }
    };

    let formik = useFormik({
        initialValues: JSON.parse(JSON.stringify(initialContacts)),
        validationSchema: ContactsSchema,
        onSubmit: async (values) => {
            if (flag === 'add') {
                try {
                    let res = await api({
                        url: `/b2b_contacts/add`,
                        method: "POST",
                        responseType: "json",
                        data: values
                    });
                    if (res?.code !== 200) {
                        Toast('error', res.data.message);
                    } else {
                        Toast("success", "Contact Added Successfully");
                        handleClose();
                        setCurrentPage(0);
                        setSearch('');
                        loadData(search, 0);
                        downloadB2BContacts(search)
                    }
                } catch (error) {
                    let er = error?.response?.message || "Something went wrong"
                    Toast("error", er)
                    if (error.response.status === 401)
                        navigate("/")
                }
            }
            if (flag === 'edit') {
                try {
                    let res = await api({

                        url: `/b2b_contacts/edit/${id}`,
                        method: "PUT",
                        responseType: "json",
                        data: values
                    });
                    if (res?.code !== 200) {
                        Toast('error', res.data.message);
                        handleClose()
                        loadData(search, currentPage);
                        downloadB2BContacts(search)
                        values.name = ''
                        values.designation = ''
                        values.official_email = ''
                        values.personal_email = ''
                        values.mobile = ''
                        values.company = ''
                        values.location = ''
                        values.category = ''
                        values.source = ''
                    } else {
                        Toast("success", "Contact updated Successfully");
                        handleClose()
                        loadData(search, currentPage);
                        downloadB2BContacts(search)
                        values.name = ''
                        values.designation = ''
                        values.official_email = ''
                        values.personal_email = ''
                        values.mobile = ''
                        values.company = ''
                        values.location = ''
                        values.category = ''
                        values.source = ''
                    }

                } catch (error) {
                    let er = error?.response?.message || "Something went wrong"
                    Toast("error", er)
                    if (error.response.status === 401)
                        navigate("/")
                }
            }
        }
    });

    const downloadSampleExcel = () => {
        const wb = XLSX.utils.book_new();
        const wsData = [['Name', 'Designation', 'Official_Email', 'Personal_Email', 'Mobile', 'Company_Name', 'Location', 'Category', 'Source']]; // Column names
        const ws = XLSX.utils.aoa_to_sheet(wsData);
        XLSX.utils.book_append_sheet(wb, ws, 'SampleSheet');
        XLSX.writeFile(wb, 'SampleContacts.xlsx'); // Download the file
    };

    const downloadB2BContacts = async (searchString = '') => {
        try {
            if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
                setLoader(true);
                let res = await api({
                    url: `/b2b_contacts/downloadB2BData`,
                    method: "POST",
                    responseType: "json",
                    data: {
                        search: searchString
                    }
                });
                if (res?.code !== 200) {
                    toast.error(res?.data?.message)
                } else {
                    setDownloadData(res?.data?.data);
                    setuserId(res.data.user_id);
                    setLoader(false);
                }
            }
        } catch (error) {
            setLoader(false);
            if (error.response.status === 401)
                navigate("/")
        }
    }


    const csvHeaders = [
        { label: "Name", key: "Name" },
        { label: "Designation", key: "Designation" },
        { label: "Official_Email", key: "Official_Email" },
        { label: "Personal_Email", key: "Personal_Email" },
        { label: "Mobile", key: "Mobile" },
        { label: "Company_Name", key: "Company_Name" },
        { label: "Location", key: "Location" },
        { label: "Category", key: "Category" },
        { label: "Source", key: "Source" },
    ];

    return (
        <>
            <SlDrawer label="Are you sure!" open={del} onSlRequestClose={handleRequestClose} onSlAfterHide={handledelClose} style={{ '--size': '30vw' }}>
                {/* <p><span style={{ fontFamily: "Arial", fontWeight: "bold" }}>{delname}</span> will be deleted</p> */}
                <p><span style={{ fontFamily: "Arial", fontWeight: "bold" }}>Selected Contacts</span> will be deleted</p>

                <div className='d-flex gap-2'>
                    <Button variant="success" onClick={() => setDel(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={async () => { setDel(false); await deleteContact(selectedRecords); setSelectAll(false); setSelectedRecords([]) }}>Confirm</Button>
                </div>
            </SlDrawer>
            <div className="creativeListPage flex flex-col h-[calc(100vh-72px)]">
              <div className="cl-card flex min-h-0 flex-1 flex-col">
                <header className="cl-header shrink-0">
                  <div className="cl-title-block">
                    <h1 className="cl-title">B2B Contacts</h1>
                    <p className="cl-subtitle">{data?.length || 0} contacts</p>
                  </div>
                  <div className="cl-toolbar cl-toolbar--inline">

                {localStorage.getItem("role") === roles.b2b ? (< div className="flex justify-end">
                    {selectedRecords.length > 0 && (
                        <SlButton variant="primary" size="medium" onClick={async () => { setDel(true) }}>Delete Selected</SlButton>
                    )}
                </div>
                ) : null}

                <SlInput className="cl-search" size="medium" id="myInput" onSlInput={debounce(searchData, 500)} placeholder="Search By Company / Category / Location / Designation" >
                    <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
                </SlInput>
                {(localStorage.getItem("role") === roles.b2b) ? (<div className="moreOptions">
                    {(localStorage.getItem("role") === roles.b2b) ? (<div>
                        <label className="m-0">
                            <i className="bi bi-download px-2 py-1 rounded-lg  bg-slate-100 hover:text-cyan-500 cursor-pointer hover:bg-slate-150" data-toggle="tooltip" title="Download Sample File" onClick={downloadSampleExcel}></i>
                        </label>
                    </div>) : null}

                    {(localStorage.getItem("role") === roles.b2b) ? (<div className="d-flex">
                        <CSVLink
                            data={downloadData}
                            headers={csvHeaders}
                            filename={`B2B_contacts.csv`}
                        >
                            <i className="bi bi-download px-2 py-1 rounded-lg  bg-slate-100 hover:text-cyan-500 cursor-pointer hover:bg-slate-150" data-toggle="tooltip" title="Download Birdview Data"></i>
                            {/* <sl-icon-button
                                    library="lucide"
                                    title="Download Data"
                                    name="download"
                                ></sl-icon-button> */}
                        </CSVLink>
                    </div>) : null}

                    {(localStorage.getItem("role") === roles.b2b) ? (<div className='d-flex'>
                        <label htmlFor="file" className="m-0">
                            <i className="bi bi-arrow-up-circle px-2 py-1 rounded-lg  bg-slate-100 hover:text-cyan-500 cursor-pointer hover:bg-slate-150" data-toggle="tooltip" title="Upload Contacts File"></i>
                            <input type="file" id="file" style={{ display: "none" }} name="file"
                                {...register("file_xlsx", {
                                    required: false,
                                    onChange: (e) => handleFileUpload(e),
                                })} />
                        </label>

                        {isLoading ? (
                            <div className="loader">
                                <div className="spinner-border text-primary" role="status"  >
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : null}
                    </div>) : null}
                </div>) : null}

                {(localStorage.getItem("role") === roles.b2b) ? (<SlButton size="medium" variant="primary" onClick={() => { handleShow("add", {}); setFlag('add') }}>Add Contact</SlButton>) : null}
                  </div>
                </header>
            <SlDrawer label="Create Contact" open={show} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose} >
                <form onSubmit={formik.handleSubmit}>
                    <div className="mb-3">
                        <label className="mb-1"> Name</label><span className="text-red-600">*</span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Name"
                            aria-label=""
                            name="name"
                            value={formik.values.name}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.name ? (
                            <div className="text-red-600">{formik.errors.name}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1"> Designation</label><span className="text-red-600">*</span>
                        <input
                            className="form-control"
                            type='text'
                            name='designation'
                            placeholder='Enter Designation'
                            aria-label=""
                            value={formik.values.designation}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.designation ? (
                            <div className="text-red-600">{formik.errors.designation}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1">Official Email</label>
                        <input
                            type='email'
                            className="form-control"
                            placeholder='Enter Official Email'
                            name='official_email'
                            aria-label=""
                            value={formik.values.official_email}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.official_email ? (
                            <div className="text-red-600">{formik.errors.official_email}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1">Personal Email</label>
                        <input
                            type='email'
                            className="form-control"
                            placeholder='Enter Personal Email'
                            name='personal_email'
                            aria-label=""
                            value={formik.values.personal_email}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.personal_email ? (
                            <div className="text-red-600">{formik.errors.personal_email}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1"> Mobile No</label>
                        <input
                            className="form-control"
                            type='tel'
                            name='mobile'
                            placeholder='Enter Mobile No'
                            aria-label=""
                            value={formik.values.mobile}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.mobile ? (
                            <div className="text-red-600	">{formik.errors.mobile}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1"> Company Name</label>
                        <input
                            className="form-control"
                            type='text'
                            name='company'
                            placeholder='Enter Company Name'
                            aria-label=""
                            value={formik.values.company}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.company ? (
                            <div className="text-red-600">{formik.errors.company}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1"> Location</label>
                        <input
                            className="form-control"
                            type='text'
                            name='location'
                            placeholder='Enter location'
                            aria-label=""
                            value={formik.values.location}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.location ? (
                            <div className="text-red-600	">{formik.errors.location}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1"> Category</label>
                        <input
                            className="form-control"
                            type='text'
                            name='category'
                            placeholder='Enter Category'
                            aria-label=""
                            value={formik.values.category}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.category ? (
                            <div className="text-red-600">{formik.errors.category}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1"> Source</label>
                        <input
                            className="form-control"
                            type='text'
                            name='source'
                            placeholder='Enter Source'
                            aria-label=""
                            value={formik.values.source}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.source ? (
                            <div className="text-red-600">{formik.errors.source}</div>
                        ) : null}
                    </div>
                    <div slot="footer">
                        <SlButton
                            type="submit"
                            variant="primary"
                            size="small"
                            onClick={(e) => setSubmit(true)}>Submit</SlButton>
                    </div>

                </form>
            </SlDrawer>
            <div className="cl-table-wrap flex-1 min-h-0 overflow-y-auto">
                <table className="cl-table cl-table--multi">
                    <thead>
                        <tr>
                            {(localStorage.getItem("role") === roles.b2b) ? (<th>
                                <input
                                    type="checkbox"
                                    checked={selectAll}
                                    onChange={toggleSelectAll}
                                />
                            </th>) : null}
                            <th >Name</th>
                            <th>Designation</th>
                            <th >Official Email</th>
                            <th >Personal Email</th>
                            <th >Mobile</th>
                            {(localStorage.getItem("role") === roles.salesperson) ? (<th>Expiry Date</th>) : null}
                            <th >Company Name</th>
                            <th>Location</th>
                            <th>Category</th>
                            {(localStorage.getItem("role") === roles.b2b) ? (<th>Source</th>) : null}
                            <th>Actions</th>
                        </tr>
                    </thead>
                    {(data?.length && !loader) ? (
                        <tbody>
                            {data.map((item) => {
                                return (
                                    <tr key={item.contact_id}>
                                        {(localStorage.getItem("role") === roles.b2b) ? (<td data-label="Select">
                                            <input
                                                type="checkbox"
                                                className="h-4 w-4 cursor-pointer accent-[#4952FA]"
                                                checked={selectedRecords.includes(item.contact_id)}
                                                onChange={() => toggleCheckbox(item.contact_id)}
                                            />
                                        </td>) : null}
                                        <td className="cl-name" data-label="Name">{item.name}</td>
                                        <td data-label="Designation">{item.designation || '-'}</td>
                                        {(localStorage.getItem("role") === roles.b2b) ? (<td data-label="Official Email">{item.official_email || '-'}</td>) : <td data-label="Official Email">{item.official_email || 'xxxxxxxxxx@gmail.com'}</td>}
                                        {(localStorage.getItem("role") === roles.b2b) ? (<td data-label="Personal Email">{item.personal_email || '-'}</td>) : <td data-label="Personal Email">{item.personal_email || 'xxxxxxxxxx@gmail.com'}</td>}
                                        {(localStorage.getItem("role") === roles.b2b) ? (<td data-label="Mobile">{item.mobile || '-'}</td>) : <td data-label="Mobile">{item.mobile || '+91xxxxxxxxxx'}</td>}
                                        {(localStorage.getItem("role") === roles.salesperson) ? (<td data-label="Expiry Date">{(item.expiry) ? (formatDate(item.expiry)) : "-"}</td>) : null}
                                        <td data-label="Company Name">{item.company || '-'}</td>
                                        <td data-label="Location">{item.location || '-'}</td>
                                        <td data-label="Category">{item.category || '-'}</td>
                                        {(localStorage.getItem("role") === roles.b2b) ? (<td data-label="Source">{item.source}</td>) : null}
                                        <td data-label="Actions">
                                            <div className="cl-actions">
                                                {(localStorage.getItem("role") === roles.b2b) ? (< SlTooltip content="Edit Contact">
                                                    <SlIconButton
                                                        library="lucide"
                                                        name="edit"
                                                        onClick={() => { handleShow("edit", item); setFlag('edit'); setId(item.contact_id) }}></SlIconButton>
                                                </SlTooltip>) : null}
                                                <form action="" method="POST">
                                                    {(localStorage.getItem("role") === roles.salesperson && (item.status === null || item.status === 2)) ? (<SlTooltip content="Request Details">
                                                        <SlIconButton
                                                            library="lucide"
                                                            name="users"
                                                            onClick={() => { setContactId(item.contact_id); sendRequest(item.contact_id) }}
                                                        >
                                                        </SlIconButton>
                                                    </SlTooltip>) : item.status}
                                                </form>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>) : ((!data?.length && !loader)
                            ? <NoDataFound colspan="11" />
                            : <TableLoader colspan="11" />
                    )
                    }
                </table>
            </div>
            {totalPages > 1 && (
              <div className="cl-pagination shrink-0 !justify-between">
                <span className="self-center text-sm text-slate-500">Showing {data?.length || 0} of {total} contacts</span>
                <Paginator pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} />
              </div>
            )}
              </div>
            </div>
        </>
    )
}
export default Contacts